module.exports = __webpack_public_path__ + "img/ruteo.620e96d2.png";